<template>
    <h6 v-if="component.tag === 'h6'" :class="headerClasses" :style="headerStyle"
        :contenteditable="isEditable"
        @blur="onEditEnd"
        v-text="getHeaderValue">
    </h6>
    <h5 v-else-if="component.tag === 'h5'" :class="headerClasses" :style="headerStyle"
        :contenteditable="isEditable"
        @blur="onEditEnd"
        v-text="getHeaderValue">
    </h5>
    <h4 v-else-if="component.tag === 'h4'" :class="headerClasses" :style="headerStyle"
        :contenteditable="isEditable"
        @blur="onEditEnd"
        v-text="getHeaderValue">
    </h4>
    <h3 v-else-if="component.tag === 'h3'" :class="headerClasses" :style="headerStyle"
        :contenteditable="isEditable"
        @blur="onEditEnd"
        v-text="getHeaderValue">
    </h3>
    <h2 v-else-if="component.tag === 'h2'" :class="headerClasses" :style="headerStyle"
        :contenteditable="isEditable"
        @blur="onEditEnd"
        v-text="getHeaderValue">
    </h2>
    <h1 v-else :class="headerClasses" :style="headerStyle"
        :contenteditable="isEditable"
        @blur="onEditEnd"
        v-text="getHeaderValue">
    </h1>
</template>

<script>
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'HeaderRenderer',
        props: ['component', 'headerValue', 'layout'],
        data () {
            return {
                model: webase.model
            }
        },
        computed: {
            getHeaderValue() {
                return this.headerValue ? this.headerValue : this.component.value
            },

            headerClasses() {
                return `header-font rounded ${this.marginClasses} ${this.paddingClasses} ${this.colorClasses} ${this.sizeClasses} ${this.textAlignClasses}`.trim()
            },

            marginClasses() {
                if(!this.component.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.component.margin)
            },

            paddingClasses() {
                if (!this.component.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.component.padding)
            },

            headerStyle() {
                let styles = {}

                if(this.isCustomColor) {
                    styles['color'] = this.component.style.color
                }

                if(this.component.includeBackground) {

                    if(this.isCustomBgColor) {
                        styles['backgroundColor'] = this.component.style.backgroundColor
                    }

                    styles['opacity'] = this.component.style.opacity ? this.component.style.opacity : 0.8
                }

                if(this.layout && this.layout.theme_id) {
                    return styles
                }

                if(this.model.website && this.model.website.metadata && this.model.website.metadata['headerFont']) {
                    let textFont = this.model.website.metadata['headerFont'] ? this.model.website.metadata['headerFont'] : 'Montserrat'

                    if(textFont !== 'Montserrat') {
                        webase.utils.ui.injectFont(textFont)
                    }

                    styles['fontFamily'] = textFont
                }

                return styles
            },

            isCustomColor() {
                return this.component.style && this.component.style.color && this.component.style.color.indexOf('#') === 0
            },

            isCustomBgColor() {
                return this.component.style && this.component.style.backgroundColor && this.component.style.backgroundColor.indexOf('#') === 0
            },

            colorClasses() {
                let classes = ''

                if(this.layout && this.layout.theme_id) {
                    return classes
                }

                if(this.component.style.color !== 'custom' && this.component.style.color.indexOf('#') !== 0 ) {
                    classes = `text-${this.component.style.color}`
                }

                if(this.component.includeBackground && this.component.style.backgroundColor !== 'custom' && this.component.style.backgroundColor.indexOf('#') !== 0 ) {
                    classes = classes + ` bg-${this.component.style.backgroundColor}`
                }

                return classes
            },

            sizeClasses() {
                if(!this.component.style.size) {
                    return ''
                }

                return `${this.component.style.size}`
            },

            textAlignClasses() {
                if(!this.component.style.align) {
                    return ''
                }

                return `${this.component.style.align}`
            },

            isEditable() {
                let routeName = this.$route.name
                console.log('Header renderer is editable')
                console.log(routeName)
                return routeName === 'view-editor' || routeName === 'page-editor' || routeName === 'layout-editor'
            }
        },
        mounted() {

            if(!this.component.style) {
                this.component.style = {
                    color: 'dark',
                    align: 'text-left'
                }
            }

            if(!this.component.style.align) {
                this.component.style.align = 'text-left'
            }

            if(this.component.animate === undefined) {
                this.component.animate = false
            }

            if(!this.component.animation) {
                this.component.animation = new PageFactory().defaultAnimation()
            }
        },
        methods: {
            onEditEnd(event){
                this.component.value = event.target.innerText
            }
        }
    }
</script>

<style>

</style>
